/**
 * Created by tomers on 5/31/2015.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/dataSourcesTabsLayout.tmpl");

    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var TabsBar = require("ui/tabsbar/TabsBar");
    var Button = require("ui/button/Button");


    var DataSourcesTabsLayout = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        DataSourcesTabsLayout = Marionette.Layout.extend({
            className: "data-sources-tabs-layout",
            template: template,
            ui: {
                tabsContainer: ".tabs-component-container",
                doneButton: ".button-done"
            },
            regions: {
                selectedTabRegion: ".selected-tab-container"
            },
            uiComponents: {
                tabs: {
                    type: TabsBar,
                    options: {
                        el: "view.ui.tabsContainer",
                        permutation: TabsBar.PERMUTATION.D,
                        commitStateChange: false,
                        collection: "view.tabsCollection"
                    },
                    events: {
                        "change:selection": "_onHeaderTabsChange"
                    }
                },
                doneBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.doneButton"
                    },
                    events: {
                        "click": "_onDoneClick"
                    }
                }
            },

            initialize: function(options) {
                this._initialize(options);
            },

            onRender: function() {
                this._onRender();
            },

            setSelectedTab: function(tabId) {
                this._setSelectedTab(tabId);
            },

            _initialize: function(options) {
                this.channel = LEManager.media.channel("dataSourcesTabs");
                this.tabsCollection = this._getTabsCollection(options.tabs);
                this._setSelectedTab(options.selectedTab);
            },

            _onRender: function() {
                this.listenTo(this, "page:closeButtonClick", this._onCloseButtonClick);
            },

            _setSelectedTab: function(tabId) {
                this.tabsCollection.selectModel(tabId);
            },

            _getTabsCollection: function(tabs){
                var tabsCollection = new TabsBar.TabCollection(tabs);
                return SelectableCollectionDecorator.decorate(tabsCollection);
            },

            _onHeaderTabsChange: function(componentName, eventName, selectedTabId) {
                this.channel.trigger("dataSourcesTabs:tab:change", selectedTabId);
            },

            _onCloseButtonClick: function() {
                this.channel.trigger("dataSourcesTabs:page:close");
            },

            _onDoneClick: function() {
                this.channel.trigger("dataSourcesTabs:page:close");
            }
        });

    }

    LE.module("LEManager", moduleDefinition);


    return DataSourcesTabsLayout;
});
